import { createFileRoute, redirect } from "@tanstack/react-router";
import { sitzungQuery } from "../../auth";
import { aktiveVorschau } from "../../lib/kundenVorschau";

/**
 * Die zweite Schwelle (T014): Alles darunter ist Team-Gebiet. Ein
 * Kundenkonto landet hier gar nicht erst auf einer Fehlerseite, sondern
 * sanft auf seinem eigenen Dashboard — die eigentliche Abweisung macht
 * ohnehin das Backend (Rollen-Schranke, 403).
 *
 * Wie `_angemeldet` eine pathless layout route: Sie taucht in keiner
 * Adresse auf, die URLs bleiben also `/kunden`, `/produktionen` usw.
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter")({
	beforeLoad: async ({ context }) => {
		const sitzung = await context.queryClient.ensureQueryData(sitzungQuery);

		// In der Kunden-Vorschau ist auch ein Team-Konto „Kunde" — Team-Seiten
		// gibt es dann nicht, das Backend gäbe ohnehin 403.
		if (sitzung === null || sitzung.rolle !== "mitarbeiter" || aktiveVorschau() !== null) {
			throw redirect({ to: "/" });
		}
	},
});
